const en = {
  invitationSent: 'You have invited a user',
  invitationDescription: '{{name}} was invited to collaborate on Wirk.',
  contributorInfo: 'Contributor',
  metrics: 'Metrics',
  information: 'Information',
  segments: 'Segments',
  certifications: 'Certifications',
  activity: 'Activity',
  export: 'Export',
  filter: 'Filter',
  workedHours: 'Effective time worked',
  numberOfProjects: 'Number of projects',
  volume: 'Volume',
  projectName: 'Project name',
  lastTask: 'Last task',
  tasksCompleted: 'Tasks done',
  pace: 'Pace',
  effectiveTime: 'Effective time',
  distribution: 'Distribution',
  quality: 'Quality',
  project: 'Project',
  objective: 'Objective',
  top20Percent: 'TOP 20%',
  averageCompletionTime: 'Average completion time',
  table: 'Table',
  skills: 'Skills',
  periods: {
    lastDay: 'Last day',
    last7Days: 'Last 7 days',
    lastMonth: 'Last month',
    lastYear: 'Last year',
  },
  profile: {
    description: 'This will be displayed on your profile.',
    sections: {
      general: 'General',
      socioDemographic: 'Socio-demographic',
      address: 'Address',
    },
    fields: {
      id: 'ID',
      birthDate: 'Date of birth',
      nationality: 'Nationality',
      earning: 'Income level',
      study: 'Education',
      family: 'Marital status',
      children: 'Number of children',
      job: 'Profession',
      activitySector: 'Business sector',
      address: 'Address',
      zipCode: 'Postal code',
      city: 'City',
      region: 'Region',
    },
    blacklist: {
      project: 'Project',
      title: 'Blacklisted projects',
      tasks: 'Tasks',
      averageQuality: 'Average quality',
      exclusionDate: 'Exclusion date',
    },
  },
  delete: {
    title: 'Delete the contributor',
    button: 'Delete',
    modal: {
      title: 'Delete contributor ?',
      label: 'Are you sure you want to perform this action ?',
    },
  },
};

export default en;

export type Translations = typeof en;
